export const downloadFileFromDataString = (data: string, overrideFileName?: string) => {
	const a: HTMLAnchorElement = document.createElement("a");
	a.href = data;
	a.style.display = "none";
	a.download = overrideFileName || data.slice(data.lastIndexOf("/") + 1);
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
};

export const downloadFileFromDataBlob = (data: Blob, overrideFileName: string) => {
	const url = URL.createObjectURL(data);
	const a: HTMLAnchorElement = document.createElement("a");
	a.href = url;
	a.setAttribute("download", `${overrideFileName}`);
	a.style.display = "none";
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	URL.revokeObjectURL(url);
};
